export default "__VITE_ASSET__BerVaCox__"